import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from './Skeleton';

const AvatarSkeleton = (_ref) => {
  let {
    size
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["size"]);

  return /*#__PURE__*/_jsx(Skeleton, Object.assign({
    width: size,
    height: size,
    radius: "50%"
  }, props));
};

export default AvatarSkeleton;